import createModel from "@/__main__/data-model.mjs";

export default createModel({
  patch: String, // "13.3"
  updatedAtUTC: String, // "2023-02-23 07:17:48.744778+00:00"
});
